import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import { useTranslation } from 'react-i18next';
import type { Theme } from '../../contexts/theme-context';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const themeIcons: Record<Theme, string> = {
    'light': '☀️',
    'dark': '🌙',
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-[rgb(var(--muted))] dark:bg-white/10 hover:bg-[rgb(var(--accent))] dark:hover:bg-white/20 transition-colors duration-300 focus:outline-hidden focus:ring-2 focus:ring-[rgb(var(--ring))] cursor-pointer"
      aria-label={t('theme.toggle')}
      title={t(`theme.${theme}`)}
    >
      <span className="text-xl" role="img" aria-hidden="true">
        {themeIcons[theme]}
      </span>
    </button>
  );
};

// Compact version for mobile header
export const ThemeToggleCompact: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const themeIcons: Record<Theme, string> = {
    'light': '☀️',
    'dark': '🌙',
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full hover:bg-[rgb(var(--accent))] dark:hover:bg-white/20 transition-colors duration-300 focus:outline-hidden focus:ring-2 focus:ring-[rgb(var(--ring))] cursor-pointer"
      aria-label={t('theme.toggle')}
      title={t(`theme.${theme}`)}
    >
      <span className="text-lg" role="img" aria-hidden="true">
        {themeIcons[theme]}
      </span>
    </button>
  );
};